"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAccountBridgeReceive = exports.scanAccounts = exports.isInvalidRecipient = exports.signOperation = exports.broadcast = exports.sync = void 0;
// TODO makeMockBridge need to be exploded into families (bridge/mock) with utility code shared.
const account_1 = require("@ledgerhq/coin-framework/mocks/account");
const errors_1 = require("@ledgerhq/errors");
const bignumber_js_1 = require("bignumber.js");
const prando_1 = __importDefault(require("prando"));
const rxjs_1 = require("rxjs");
const account_2 = require("../account");
const env_1 = require("../env");
const mock_1 = __importDefault(require("../generated/mock"));
const account_3 = require("../mock/account");
const operation_1 = require("../operation");
const promise_1 = require("../promise");
const MOCK_DATA_SEED = (0, env_1.getEnv)("MOCK") || "MOCK";
const broadcasted = {};
const syncTimeouts = {};
const sync = initialAccount => new rxjs_1.Observable(o => {
    const accountId = initialAccount.id;
    const sync = () => {
        if (initialAccount.name.includes("crash")) {
            o.error(new errors_1.SyncError("mock failure"));
            return;
        }
        const ops = broadcasted[accountId] || [];
        broadcasted[accountId] = [];
        o.next(acc => {
            const balance = ops.reduce((sum, op) => sum.plus((0, operation_1.getOperationAmountNumber)(op)), acc.balance);
            const nextAcc = Object.assign(Object.assign({}, acc), { blockHeight: acc.blockHeight + 1000, lastSyncDate: new Date(), operations: ops.concat(acc.operations.slice(0)), pendingOperations: [], balance, spendableBalance: balance });
            const perFamilyOperation = mock_1.default[acc.currency.id];
            const postSyncAccount = perFamilyOperation && perFamilyOperation.postSyncAccount;
            if (postSyncAccount)
                return postSyncAccount(nextAcc);
            return nextAcc;
        });
        o.complete();
    };
    syncTimeouts[accountId] = setTimeout(sync, 500);
    return () => {
        clearTimeout(syncTimeouts[accountId]);
        syncTimeouts[accountId] = null;
    };
});
exports.sync = sync;
const broadcast = ({ signedOperation }) => Promise.resolve(signedOperation.operation);
exports.broadcast = broadcast;
const signOperation = ({ account, transaction }) => new rxjs_1.Observable(o => {
    let cancelled = false;
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, promise_1.delay)(1000);
            if (cancelled)
                return;
            for (let i = 0; i <= 1; i += 0.1) {
                o.next({
                    type: "device-streaming",
                    progress: i,
                    index: i,
                    total: 10,
                });
                yield (0, promise_1.delay)(300);
            }
            o.next({
                type: "device-signature-requested",
            });
            yield (0, promise_1.delay)(2000);
            if (cancelled)
                return;
            o.next({
                type: "device-signature-granted",
            });
            const rng = new prando_1.default("");
            const op = (0, account_1.genOperation)(account, account, account.operations, rng);
            op.type = "OUT";
            op.value = transaction.amount;
            op.blockHash = null;
            op.blockHeight = null;
            op.senders = [account.freshAddress];
            op.recipients = [transaction.recipient];
            op.blockHeight = account.blockHeight;
            op.date = new Date();
            yield (0, promise_1.delay)(1000);
            if (cancelled)
                return;
            broadcasted[account.id] = (broadcasted[account.id] || []).concat(op);
            o.next({
                type: "signed",
                signedOperation: {
                    operation: Object.assign({}, op),
                    expirationDate: null,
                    signature: "",
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
    return () => {
        cancelled = true;
    };
});
exports.signOperation = signOperation;
const isInvalidRecipient = (recipient) => {
    if (recipient.includes("criticalcrash"))
        throw new Error("isInvalidRecipient_mock_criticalcrash");
    return recipient.includes("invalid") || recipient.length <= 3;
};
exports.isInvalidRecipient = isInvalidRecipient;
const subtractOneYear = date => new Date(new Date(date).setFullYear(new Date(date).getFullYear() - 1));
const scanAccounts = ({ currency }) => new rxjs_1.Observable(o => {
    let unsubscribed = false;
    function job() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO offer a way to mock a failure
            const nbAccountToGen = 3;
            for (let i = 0; i < nbAccountToGen && !unsubscribed; i++) {
                const isLast = i === 2;
                yield (0, promise_1.delay)(500);
                const account = (0, account_3.genAccount)(`${MOCK_DATA_SEED}_${currency.id}_${i}`, {
                    operationsSize: isLast ? 0 : 100,
                    currency,
                });
                account.unit = currency.units[0];
                account.index = i;
                account.operations = isLast
                    ? []
                    : account.operations.map(operation => (Object.assign(Object.assign({}, operation), { date: subtractOneYear(operation.date) })));
                account.used = isLast ? false : account.used;
                account.name = "";
                account.name = (0, account_2.validateNameEdition)(account);
                if (isLast) {
                    account.spendableBalance = account.balance = new bignumber_js_1.BigNumber(0);
                }
                const perFamilyOperation = mock_1.default[currency.id];
                const postScanAccount = perFamilyOperation && perFamilyOperation.postScanAccount;
                if (postScanAccount)
                    postScanAccount(account, {
                        isEmpty: isLast,
                    });
                if (!unsubscribed)
                    o.next({
                        type: "discovered",
                        account,
                    });
            }
            if (!unsubscribed)
                o.complete();
        });
    }
    job();
    return () => {
        unsubscribed = true;
    };
});
exports.scanAccounts = scanAccounts;
const makeAccountBridgeReceive = () => account => (0, rxjs_1.of)({
    address: account.freshAddress,
    path: account.freshAddressPath,
});
exports.makeAccountBridgeReceive = makeAccountBridgeReceive;
//# sourceMappingURL=mockHelpers.js.map